import Modal from "./Modal";
const WithModal =
  (WrappedComponent) =>
  ({ open, title, handleClose, dialogClasses, disableEnforceFocus, headerActions, ...otherProps }) =>
    (
      <Modal open={open} title={title} handleClose={handleClose} dialogClasses={dialogClasses} disableEnforceFocus={disableEnforceFocus} headerActions={headerActions}>
        <WrappedComponent handleClose={handleClose} {...otherProps} />
      </Modal>
    );

export default WithModal;
